<template>
  <div class="item">
    <div class="form">
      <div class="form-title">收件人</div>
      <div class="form-element">
        <InputText
          id="name"
          v-model="contact.name"
          :class="{
            'p-invalid': $page.props.errors[index + '.name'],
          }"
        />
        <div class="form-element-sub">
          <RadioButton
            :id="'sex_mr_' + index"
            name="sex"
            :value="1"
            v-model="contact.sex"
          /><label :for="'sex_mr_' + index">先生</label>
        </div>
        <div class="form-element-sub">
          <RadioButton
            :id="'sex_ms_' + index"
            name="sex"
            :value="0"
            v-model="contact.sex"
          /><label :for="'sex_ms_' + index">小姐</label>
        </div>
      </div>
      <div v-if="$page.props.errors[index + '.name']" class="error_information">
        {{ $page.props.errors[index + ".name"] }}
      </div>
    </div>

    <div class="form">
      <div class="form-title">連絡電話</div>
      <div class="form-element">
        <InputText
          id="phone"
          v-model="contact.phone"
          :class="{
            'p-invalid': $page.props.errors[index + '.phone'],
          }"
        />
      </div>
      <div
        v-if="$page.props.errors[index + '.phone']"
        class="error_information"
      >
        {{ $page.props.errors[index + ".phone"] }}
      </div>
    </div>

    <div class="form">
      <div class="form-title">
        <label for="address">收件地址</label>
      </div>
      <div class="form-element-subs">
        <div class="form-element-sub">
          <Dropdown
            id="delivery_address"
            class="w-32"
            v-model="delivery.city"
            :options="taiwan_districts"
            optionLabel="name"
            placeholder="縣市"
            :filter="true"
            :class="{
              'p-invalid': $page.props.errors[index + '.shipping_info.address'],
            }"
            filterPlaceholder="尋找"
            emptyFilterMessage="沒有符合的結果"
            @change="delivery.district = null"
          />
          <Dropdown
            id="district"
            class="w-36"
            v-model="delivery.district"
            :options="selected_city_delivery_new_districts"
            optionLabel="name"
            placeholder="行政區"
            :filter="true"
            :class="{
              'p-invalid': $page.props.errors[index + '.shipping_info.address'],
            }"
            filterPlaceholder="尋找"
            emptyFilterMessage="沒有符合的結果"
            :disabled="!delivery.city"
          />
        </div>
        <div>
          <InputText
            v-model="delivery.address"
            class="w-64"
            type="text"
            placeholder="路名及門牌號碼"
            :class="{
              'p-invalid': $page.props.errors[index + '.shipping_info.address'],
            }"
            :disabled="!delivery.district"
          />
          <div
            v-if="$page.props.errors[index + '.shipping_info.address']"
            class="error_information"
          >
            <i class="pi pi-arrow-up" />
            {{ $page.props.errors[index + ".shipping_info.address"] }}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-2">
      <Button label="移除" @click="$emit('deleteContact', index)" />
    </div>
  </div>
</template>

<script>
import TaiwanDistricts from "@/TaiwanDistricts.json";
import InputText from "primevue/inputtext";
import RadioButton from "primevue/radiobutton";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";

export default {
  components: {
    InputText,
    RadioButton,
    Dropdown,
    Button,
  },
  watch: {
    delivery: {
      handler(delivery) {
        this.contact.shipping_info = {
          city: delivery.city?.name ?? null,
          district: delivery.district,
          address: delivery.address,
        };
      },
      deep: true,
    },
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      taiwan_districts: TaiwanDistricts,
      delivery: {
        city: null,
        district: null,
        address: null,
      },
    };
  },
  computed: {
    selected_city_delivery_new_districts() {
      if (!this.delivery.city) return [];
      return this.delivery.city.districts;
    },
  },
  mounted() {
    this.delivery = {
      city:
        this.taiwan_districts.find((city) => {
          return city.name == this.contact.shipping_info?.city;
        }) ?? null,
      district: this.contact.shipping_info?.district ?? null,
      address: this.contact.shipping_info?.address ?? null,
    };
  },
};
</script>

<style lang="postcss">
.item {
  @apply relative border rounded border-fh-gray-light p-2 m-2;
}
</style>